import { Box, Typography } from '@mui/material';
import { CompoundCardProps } from '../../types/reports';
import CompoundLevelsBubbleChart from '../../components/charts/CompoundLevelsBubbleChart';
import { formatDateWithOrdinalSuffix } from '../../utils';
import { BubbleChartChipMeaning } from './BubbleChartChipMeaning';
import { useThemeContext } from '../../contexts/BaseThemeContextProvider';

type BubbleViewContentProps = {
  reportDate: string;
  compoundDataList: CompoundCardProps[];
};
export const BubbleViewContent = ({ compoundDataList, reportDate }: BubbleViewContentProps) => {
  const { theme } = useThemeContext();
  const formattedReportData = formatDateWithOrdinalSuffix(reportDate, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  return (
    <Box
      sx={{
        marginBottom: '16px',
        borderRadius: '16px',
        background: theme.custom.report.bubbleViewContent.backgroundColor,
        padding: '19px',
      }}
    >
      <Box display="flex" gap="10px" justifyContent="space-between" alignItems="center">
        <Box>
          <Typography
            variant="body1"
            component="span"
            sx={{
              fontSize: '1.5rem',
              marginBottom: '16px',
              color: theme.custom.report.bubbleViewContent.typography.body1.color,
            }}
          >
            All compounds{' '}
          </Typography>
          <Typography
            variant="body2"
            component="span"
            sx={{ marginBottom: '16px', color: theme.custom.report.bubbleViewContent.typography.body2.color }}
          >
            {formattedReportData}
          </Typography>
        </Box>
        <BubbleChartChipMeaning />
      </Box>
      <Box>
        <CompoundLevelsBubbleChart compoundDataList={compoundDataList} />
      </Box>
    </Box>
  );
};
